import React, { useContext } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { ToggleButton } from "../ToggleButton";

import CookieIcon from "./CookieIcon";
import CookieHeadline from "./CookieHeadline";
import CookieDescription from "./CookieDescription";
import CookieAdditionalInfo from "./CookieAdditionalInfo";
import CookieConsentContext from "./CookieConsentContext";

import styles from "./CookieConsent.scss";

function CookieOption({
  children,
  name,
  required,
  toggleUncheckedCaption,
  toggleCheckedCaption,
  onChange,
  ...otherProps
}) {
  const { acceptCookie, denyCookie, acceptedCookies } = useContext(
    CookieConsentContext
  );

  const onToggle = (isChecked) => {
    if (isChecked) {
      acceptCookie(name);
    } else {
      denyCookie(name);
    }

    onChange(isChecked);
  };

  const optionClassName = classNames(styles.option, {
    "is-active": acceptedCookies.includes(name) || required,
  });

  const toggleChecked = acceptedCookies.includes(name) || required;
  const toggleCaption = toggleChecked
    ? toggleCheckedCaption
    : toggleUncheckedCaption;

  return (
    <div className={optionClassName} {...otherProps}>
      {children}

      <div className={styles["toggle-container"]}>
        <ToggleButton
          disabled={required}
          checked={toggleChecked}
          onToggle={onToggle}
          offText={toggleUncheckedCaption}
          onText={toggleCheckedCaption}
          customClass={styles["option-toggle"]}
        >
          {toggleCaption}
        </ToggleButton>
      </div>
    </div>
  );
}

CookieOption.defaultProps = {
  required: false,
  toggleUncheckedCaption: "Nicht erlauben",
  toggleCheckedCaption: "Erlauben",
  onChange: () => {},
};

CookieOption.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  toggleUncheckedCaption: PropTypes.string,
  toggleCheckedCaption: PropTypes.string,
  onChange: PropTypes.func,
};

CookieOption.Icon = CookieIcon;
CookieOption.Headline = CookieHeadline;
CookieOption.Description = CookieDescription;
CookieOption.AdditionalInfo = CookieAdditionalInfo;

CookieOption.displayName = "CookieConsent.Option";

export default CookieOption;
